import parse from "html-react-parser";
import { Text, Flex } from "@chakra-ui/react";

import Success from "../../../assets/svg/success";

export default function Index({ successMessage }) {
  return (
    <Flex
      p="3"
      bg="white"
      opacity=".75"
      width="100vw"
      flexWrap="wrap"
      borderBottomWidth={3}
      justifyContent="center"
      borderBottomColor="maroon"
    >
      <Flex
        flexDirection="row"
        alignItems="center"
        justifyContent="flex-start"
        width={{ base: "90%", "2xl": "1350px" }}
      >
        <Success />
        <Text ml="10" color="maroon" variant="descriptionText">
          {parse(successMessage)}
        </Text>
      </Flex>
    </Flex>
  );
}
